import {
  WHEEL_REGISTER_ALL,
  WHEEL_REGISTER_GET,
  WHEEL_REGISTER_POST,
  WHEEL_REGISTER_PUT,
  WHEEL_REGISTER_DELETE,
  WHEEL_REGISTER_LOADING,
  WHEEL_REGISTER_ERROR,
  WHEEL_REGISTER_RESET,
} from '../../actions/types';

const initialState = {
  wheel: null,
  isLoading: true,
  isCompleted: false,
};
// eslint-disable-next-line func-names
export default function (state = initialState, action) {
  switch (action.type) {
    case WHEEL_REGISTER_LOADING:
      return { isLoading: true, isCompleted: false };
    case WHEEL_REGISTER_ERROR:
      return { isLoading: false, isCompleted: false };
    case WHEEL_REGISTER_ALL:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case WHEEL_REGISTER_GET:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case WHEEL_REGISTER_POST:
      return { isLoading: false, isCompleted: true };
    case WHEEL_REGISTER_PUT:
      return { isLoading: false, isCompleted: true };
    case WHEEL_REGISTER_DELETE:
      return { isLoading: false, isCompleted: true };
    default:
      return state;
  }
}
